// TanStack Query keys and hooks for notifications and briefs. The `notification` and `brief` SSE
// events invalidate these (see feedEvents.ts); the intervals are only a safety net.
import { queryOptions, useQuery } from "@tanstack/react-query";
import { notifyApi } from "./notifyApi";

export const notifyKeys = {
  all: ["notifications"] as const,
  list: (unseenOnly: boolean) => ["notifications", unseenOnly ? "unseen" : "all"] as const,
  briefs: ["briefs"] as const,
  brief: (id: string) => ["brief", id] as const,
};

export function notificationsQuery(unseenOnly: boolean) {
  return queryOptions({
    queryKey: notifyKeys.list(unseenOnly),
    queryFn: ({ signal }) => notifyApi.notifications(unseenOnly, signal),
    staleTime: 30_000,
    refetchInterval: 120_000,
  });
}

export function useNotifications(unseenOnly: boolean, enabled = true) {
  return useQuery({ ...notificationsQuery(unseenOnly), enabled });
}

export const briefsQuery = queryOptions({
  queryKey: notifyKeys.briefs,
  queryFn: ({ signal }) => notifyApi.briefs(signal),
  staleTime: 60_000,
  refetchInterval: 300_000,
});

export function useBriefs(enabled = true) {
  return useQuery({ ...briefsQuery, enabled });
}

export function briefQuery(id: string) {
  return queryOptions({
    queryKey: notifyKeys.brief(id),
    queryFn: ({ signal }) => notifyApi.brief(id, signal),
    staleTime: 60_000,
  });
}
